import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { ALERT_RULES_QUERY_KEY } from "./useAlertRules";

type AlertRuleResponse = components["schemas"]["AlertRuleResponse"];

export function useRestoreAlertRule() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<AlertRuleResponse, Error, string>({
    mutationFn: async (alert_rule_id) => {
      const { data, error } = await client.POST(
        "/api/alerts/rules/{alert_rule_id}/restore",
        {
          params: { path: { alert_rule_id } },
        },
      );
      if (error !== undefined) {
        throw new Error("Failed to restore alert rule");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ALERT_RULES_QUERY_KEY });
    },
  });
}
